import { FC } from "react";
import { ChequeActivityDataWithMeta, ChequeActivityDeliver } from "../types";
import {
  ActivityBody,
  ActivityBodyInfo,
  ActivityBy,
  ActivityDate,
  ActivityFooter,
  ActivityTitle,
} from "../../components";
import { addComma } from "../../../../utils";

const ChequeDeliverActivity: FC<ChequeActivityDataWithMeta> = ({
  activity,
  by,
  date,
  type,
}) => {
  const activity_ = activity as ChequeActivityDeliver;
  return (
    <>
      <ActivityTitle type={type}>تحویل چک به مدیر</ActivityTitle>
      <ActivityBody>
        <ActivityBodyInfo
          type={type}
          title="تایید شده به نام"
          value={activity_.confirmed_with}
        />
        <ActivityBodyInfo
          type={type}
          title="مبلغ"
          value={addComma(activity_.price)}
        />
      </ActivityBody>
      <ActivityFooter>
        <ActivityBy>{by}</ActivityBy>
        <ActivityDate>{date}</ActivityDate>
      </ActivityFooter>
    </>
  );
};

export default ChequeDeliverActivity;
